export default {
  general: {
    showLayoutSwitchToggle: true,
    showSoldNeighbourhoods: true,
    showSoldLabel: false,
    showSoldReleases: true,
    showFavourites: true,
    canInteractSoldLivingoptions: false,
    canInteractSoldProperties: false,
    ignorePropertyStatusFiltering: ["Sold"],
  },

  filter: {
    enabled: false,
  },

  packagePage: {
    active: true,
    label: "",
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: ["Available", "Coming Soon", "On Hold", "Sold"],
    },
  },
};
